import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import BookOutlinedIcon from '@mui/icons-material/BookOutlined'

const TABS = [
  { to: '/radiology/admin/config', end: true, label: 'Overview' },
  { to: '/radiology/admin/config/enterprise', end: false, label: 'Enterprise scans' },
  { to: '/radiology/admin/config/hospital-pricing', end: false, label: 'Hospital pricing' },
  { to: '/radiology/admin/config/templates', end: false, label: 'Report templates' },
  { to: '/radiology/admin/config/option-catalogs', end: false, label: 'Option catalogs' },
  { to: '/radiology/admin/config/formula-registry', end: false, label: 'Formula registry' },
  { to: '/radiology/admin/config/dicom-gateway', end: false, label: 'DICOM Gateway' },
] as const

/**
 * Radiology configuration shell using healthcare-ui MUI Tabs (Lab catalog pattern).
 */
export function RadConfigConsoleLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const underTemplates = location.pathname.includes('/templates/')
  const current =
    TABS.find((t) =>
      t.end
        ? location.pathname === t.to
        : location.pathname === t.to ||
          location.pathname.startsWith(`${t.to}/`) ||
          (t.to.endsWith('/templates') && underTemplates),
    )?.to ?? '/radiology/admin/config'

  return (
    <Box data-testid="rad-config-console" sx={{ minHeight: 'calc(100vh - 4rem)' }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          px: { xs: 1, sm: 2 },
          pt: 1.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <BookOutlinedIcon fontSize="small" color="primary" />
          <Box>
            <Typography variant="subtitle2" fontWeight={700}>
              Radiology configuration
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Enterprise catalog → hospital pricing → templates
            </Typography>
          </Box>
        </Box>
        <Tabs
          value={current}
          onChange={(_, value) => navigate(value)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: 42,
            '& .MuiTab-root': { minHeight: 42, py: 1, fontSize: '0.8rem', fontWeight: 700 },
          }}
        >
          {TABS.map((item) => (
            <Tab
              key={item.to}
              label={item.label}
              value={item.to}
              data-testid={`rad-config-tab-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            />
          ))}
        </Tabs>
      </Box>
      <Box component="main" sx={{ minWidth: 0 }}>
        <Outlet />
      </Box>
    </Box>
  )
}
